import { render, staticRenderFns } from "./Couple.vue?vue&type=template&id=0ea9f5d3&scoped=true&"
import script from "./Couple.vue?vue&type=script&lang=js&"
export * from "./Couple.vue?vue&type=script&lang=js&"
import style0 from "./Couple.vue?vue&type=style&index=0&id=0ea9f5d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea9f5d3",
  null
  
)

export default component.exports